import _ from 'underscore';
import { Base } from './Base';

export class StringBase extends Base {
  static create() {
    return null;
  }

  static isValidType(target) {
    return target === null || _.isString(target);
  }

  static isValid(target) {
    return this.isValidType(target) && target && target.length > 0;
  }

  static isEqual(a, b) {
    const eq = Base.isEqual(a, b);
    if (eq !== undefined) {
      return eq;
    }
    return a.trim().toLowerCase() === b.trim().toLowerCase();
  }
}
